import type { Listenable } from "../../utils/Store";
import type { CommonCart, OrderData } from "../../model/CommonCartTypes";
import type { ArticleData } from "../../model/ArticleTypes";
import type { CartItemChange } from "../MiniCartStore";
import { EmployeeOrderHeader } from "../CheckoutTypes";
import { v4 as uuidv4 } from "uuid";
export type AddItemParams = {
	bundleId: string;
	quantity: number;
	comment?: string | null;
	articleData?: ArticleData;
	index?: number;
};
export interface ICartStore extends Listenable<(...args: Array<any>) => any> {
	readonly getCart: () => CommonCart | null;
	readonly getOrderData: () => OrderData | null | undefined;
	readonly getDeliveryDate: () => string | null | undefined;
	readonly addItem?: (params: AddItemParams) => Promise<void | null>;
	readonly addItems?: (params: AddItemParams[]) => Promise<void | null>;
	readonly checkOut?: (
		cartId: string | null | undefined,
		cartVersion: number | null | undefined,
		employeeOrderHeader: EmployeeOrderHeader | null | undefined,
	) => Promise<string | null | undefined>;
	readonly getCartItemChange?: () => CartItemChange | null | undefined;
	readonly isEmployeeCart: () => boolean;
	readonly isPending: () => boolean;
}
export const generateRequestId = (prefix = "BTOC") => prefix + `-${uuidv4()}`;
export const MAX_COMMENT_LENGTH = 200;
